import React from "react";
import { Link } from "react-router-dom";
import "./AboutSection.css";

const AboutSection: React.FC = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-section__wrap">
          {/* LEFT */}
          <div className="about-section__left">
            <span className="section-label">Who We Are</span>
            <h2 className="section-title">Built to solve<br/>real problems</h2>
            <div className="about-section__img-wrap">
              <img src="/image.png" alt="AJERA Infotech building" />
              {/* <img src="/what.png" alt="AJERA Infotech building" /> */}
              <div className="about-section__img-tag">Est. 2025 · Tamil Nadu</div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="about-section__right">
            <p className="about-section__text">
              AJERA Infotech is a growing technology company focused on delivering
              high-quality digital solutions. We started this company to solve
              real-life and business problems using innovative technology and
              modern software solutions.
            </p>
            <p className="about-section__text">
              Our team of engineers, designers and strategists works together to
              build products that are fast, reliable and built to scale — from
              MVPs to enterprise platforms.
            </p>
            <div className="about-section__features">
              {["Agile Development", "Transparent Communication", "On-Time Delivery", "24/7 Support"].map(f => (
                <div key={f} className="about-section__feature">
                  <span className="about-section__check">✓</span> {f}
                </div>
              ))}
            </div>
            <Link to="/about" className="btn-outline" style={{ marginTop: "2rem", display: "inline-flex" }}>
              Know More About Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
